/* Necklace page helper. Presentation only: it scrolls, focuses and clicks the EXISTING controls.
   It holds no form state, creates no inputs and never talks to the cart itself. */
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.mira-charm-configurator');
  if (!section) return;
  let tries = 0;
  const boot = () => {
    const addBtn = section.querySelector('[data-add]');
    const catalog = section.querySelector('.mira-catalog');
    if (!addBtn || !catalog) { if (tries++ < 60) setTimeout(boot, 100); return; }
    init(addBtn, catalog);
  };
  boot();

  function init(addBtn, catalog) {
    const summary = section.querySelector('.mira-summary');
    const totalEl = section.querySelector('[data-total]');
    const dock = document.createElement('div');
    dock.className = 'mj-dock';
    dock.setAttribute('role', 'region');
    dock.setAttribute('aria-label', 'Necklace quick actions');
    dock.setAttribute('aria-hidden', 'true');
    dock.innerHTML = '<div class="mj-dock__info"><span class="mj-dock__status" data-dock-status></span><strong class="mj-dock__total" data-dock-total></strong></div><div class="mj-dock__actions"><button type="button" class="mj-dock__link" data-dock-enter>Enter charm numbers</button><button type="button" class="mj-btn mj-btn--gold mj-dock__add" data-dock-add>Add to Cart</button></div>';
    document.body.append(dock);
    const statusEl = dock.querySelector('[data-dock-status]');
    const dockTotal = dock.querySelector('[data-dock-total]');
    const enterBtn = dock.querySelector('[data-dock-enter]');
    const dockAdd = dock.querySelector('[data-dock-add]');

    const rows = () => Array.from(section.querySelectorAll('.mira-charm-entry'));
    const inView = (el) => { if (!el) return false; const r = el.getBoundingClientRect(); return r.bottom > 140 && r.top < window.innerHeight - 140; };

    const enterCharms = () => {
      const inputs = rows().map((r) => r.querySelector('input')).filter(Boolean);
      const target = inputs.find((i) => !i.value.trim()) || inputs[0];
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => target.focus({ preventScroll: true }), 500);
      } else {
        const step = section.querySelector('[data-counts]')?.closest('.mira-step');
        if (step) step.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    enterBtn.addEventListener('click', enterCharms);
    dockAdd.addEventListener('click', () => { if (!addBtn.disabled) addBtn.click(); });

    let frame = 0;
    const update = () => {
      frame = 0;
      const state = (window.MIRA_NECKLACE_CONFIGURATOR || {}).state || {};
      const complete = !addBtn.disabled;
      const count = state.charmCount || 0;
      const filled = rows().filter((r) => { const i = r.querySelector('input'); return i && i.value.trim() && !r.classList.contains('mira-invalid'); }).length;
      if (complete) statusEl.textContent = [state.chain, state.length, count + (count === 1 ? ' charm' : ' charms')].filter(Boolean).join(' \u00b7 ');
      else if (!state.chain) statusEl.textContent = 'Choose your chain style';
      else if (!state.length) statusEl.textContent = 'Choose your length';
      else if (!count) statusEl.textContent = 'Choose how many charms';
      else statusEl.textContent = filled + ' of ' + count + ' charm numbers entered';
      dockTotal.textContent = complete && totalEl ? totalEl.textContent : '';
      dockAdd.textContent = addBtn.textContent.trim() || 'Add to Cart';
      dockAdd.disabled = addBtn.disabled;
      dock.classList.toggle('is-complete', complete);

      const catalogActive = inView(catalog);
      const summaryVisible = summary && inView(summary);
      const pastCatalog = catalog.getBoundingClientRect().bottom < 160;
      const progress = section.querySelector('.mira-progress');
      const started = progress ? progress.getBoundingClientRect().top < window.innerHeight * 0.5 : true;
      const lightbox = !!document.querySelector('dialog.mira-catalog-zoom[open]');
      const show = !lightbox && (catalogActive || (complete && started && !pastCatalog && !summaryVisible));
      dock.classList.toggle('is-on', show);
      dock.setAttribute('aria-hidden', String(!show));
      dock.inert = !show;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('input', schedule);
    new MutationObserver(schedule).observe(section, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    update();
  }
});
